import { render, staticRenderFns } from "./GridLoadMore.vue?vue&type=template&id=2b3239a8&scoped=true"
import script from "./GridLoadMore.vue?vue&type=script&lang=js"
export * from "./GridLoadMore.vue?vue&type=script&lang=js"
import style0 from "./GridLoadMore.vue?vue&type=style&index=0&id=2b3239a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3239a8",
  null
  
)

export default component.exports